import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * GenerateRecurrentOrders
 *
 * @private
 */
export const generateRecurrentOrders = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.GenerateRecurrentOrdersResult['result'],
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/generateRecurrentOrders', async (_payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/generateRecurrentOrders', {
      category: 'rpc',
      type: 'rpc/order/generateRecurrentOrders',
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on generateRecurrentOrders`,
      { tags: ['rpc', 'order'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `generateRecurrentOrders call failed`,
      error,
    })
  }
})
